import './axios';
import VueRouter from 'vue-router';
import { Fragment } from 'vue-frag';
import { Store } from 'vuex/types/index';

import { IRootState } from '@/store';
import vuetify from './vuetify/vuetify';
import { installAltoleap } from './altoleap';
import { registerSentry } from './sentry';
import { VueConstructor } from 'vue/types/umd';

export { vuetify };
export * from './services';

export function registerPlugins(
  Vue: VueConstructor,
  store: Store<IRootState>,
  router: VueRouter
) {
  installAltoleap(Vue, store);
  registerSentry(Vue, router);

  /**
   * Globally add fragment component
   * https://github.com/privatenumber/vue-frag?tab=readme-ov-file#register-globally
   */
  Vue.component('Fragment', Fragment);
}
export default registerPlugins;
